import { Text } from '@react-pdf/renderer'
import React, { useRef } from 'react'

interface PageTrackerProps {
  sectionId: string
  onRender: (params: { id: string; pageNumber: number }) => void
  /**
   * If true, only registers the page number once (useful for multi-page sections).
   * If false, registers on every render (useful for single-page sections).
   * @default true
   */
  registerOnce?: boolean
}

/**
 * Hidden text component that tracks page numbers during PDF rendering.
 * This component renders an empty string but uses the render callback
 * to capture and report the current page number for table of contents generation.
 */
export const PageTracker: React.FC<PageTrackerProps> = ({
  sectionId,
  onRender,
  registerOnce = true,
}) => {
  const hasRegistered = useRef(false)

  if (registerOnce) {
    return (
      <Text
        render={({ pageNumber }) => {
          if (!hasRegistered.current) {
            onRender({ id: sectionId, pageNumber })
            hasRegistered.current = true
          }
          return ''
        }}
      />
    )
  }

  return (
    <Text
      render={({ pageNumber }) => {
        onRender({ id: sectionId, pageNumber })
        return ''
      }}
    />
  )
}
